import axios from 'axios'
import { getXhrUrl } from 'client/common/url'
import { CATEGORY_FILTER_NAME, FILTER_KEYS_PARAM } from 'client/fragments/listerFragment/constants'
import { isLoading, setData } from 'client/fragments/listerFragment/store/reducer'
import { filterApplied, filterRemoved } from 'client/common/gtmEvents'

export const onFilterChange =
  ({
    format,
    lang,
    categoryCode,
    collectionId,
    ids,
    viewSize,
    term,
    userId,
    ipAddress,
    dispatch,
    active: activeImmutable,
    collection
  }) =>
  ({ name, item, items, type, id, title, filterPosition }) => {
    const active = { ...activeImmutable }

    if (!item) item = items[items.length - 1] // listFilters doesn't has item
    let value = item.value.value ? item.value.value : item.value
    if (value.includes(',')) value = encodeURIComponent(value)
    if (shouldStopProcessing(item, title, value, active, type)) {
      if (id === -1) {
        name = Object.keys(active).find(k => active[k].findIndex(i => i.value === value) !== -1)
      } else {
        return
      }
    }

    if (id === -1 && item.checked) return

    const url = new URL(document.location.href)
    const { origin, searchParams } = url

    if (categoryCode && name === CATEGORY_FILTER_NAME) {
      // open category filters as link on category page
      global.window.location.href = `${origin}${item.href}`
      return
    }
    // if user go to search page from products by brand filter and removes filter constructor load ~6 second which leads to error
    // to handle it we just redirect to home page
    if (
      !categoryCode &&
      !collectionId &&
      !term &&
      Object.entries(active).length === 1 &&
      active[name] &&
      !item.checked
    ) {
      global.window.location.href = `${origin}`
      return
    }

    const act = {
      group: name,
      type,
      checked: type === 'range' ? true : item.checked,
      value,
      label: item.label || value,
      groupTitle: title
    }

    if (act.value.includes(',')) act.value = encodeURIComponent(act.value)
    const filterEventParameters = { name: name || title, value, type, filterPosition }
    if (act.checked) {
      if (type === 'range') {
        searchParams.delete(name)
      }
      addParam(searchParams, act)
      addActiveFiltersParam(searchParams, act)
      filterApplied(filterEventParameters)
    } else {
      if (!active[act.groupTitle]?.map(i => i.value).includes(act.value)) return
      removeParam(searchParams, act, collection)
      removeActiveFiltersParam(searchParams, act, collection)
      filterRemoved(filterEventParameters)
    }

    updateActive(active, act)
    searchParams.delete('currentPage')
    updateWindowUrl(url.toString())

    dispatch(isLoading(true))
    return axios
      .get(
        getXhrUrl({
          origin,
          format,
          lang,
          userId,
          categoryCode,
          collectionId,
          ids,
          viewSize,
          searchParams
        }),
        {
          headers: { ip: ipAddress }
        }
      )
      .then(({ data }) => {
        const { products, meta, filters, breadcrumbs, page: pageData } = data || {}
        if (data.products?.collection?.length) {
          dispatch(
            setData({
              products,
              meta,
              filters: { ...filters, active },
              breadcrumbs,
              zeroResults: !data.products?.collection?.length,
              page: {
                ...pageData,
                page: 1
              }
            })
          )
        }
        dispatch(setData({ zeroResults: !products?.collection?.length }))
        dispatch(isLoading(false))
      })
  }

const addParam = (params, { group, value, type }) => {
  if (type === 'list') params.set(group, value)
  else {
    const param = params.get(group, value) || ''
    const newParam = [...param.split(','), value].filter(i => i && i.length > 0).join(',')
    params.set(group, newParam)
  }
}

const removeParam = (params, { group, value, groupTitle }, collection) => {
  const groupName = collection.find(c => c?.name === group)?.name || group || getFilterNameValue(groupTitle, collection)

  if (groupName === CATEGORY_FILTER_NAME) params.delete(groupName)

  const param = params.get(groupName) || ''
  const newParam = param
    .split(',')
    .filter(i => i !== value)
    .filter(i => i && i.length > 0)
    .join(',')
  newParam.length > 0 ? params.set(groupName, newParam) : params.delete(groupName)
}
const addActiveFiltersParam = (params, { group }) => {
  const filterKeys = params.get(FILTER_KEYS_PARAM) || ''
  if (filterKeys.split(',').includes(group)) return
  const newFilterKeys = [...filterKeys.split(','), group].filter(i => i && i.length > 0).join(',')
  params.set(FILTER_KEYS_PARAM, newFilterKeys)
}

const removeActiveFiltersParam = (params, { group, groupTitle }, collection) => {
  const groupName = collection.find(c => c?.name === group)?.name || group || getFilterNameValue(groupTitle, collection)
  if (params.get(groupName)) return
  const filterKeys = params.get(FILTER_KEYS_PARAM) || ''
  const newFilterKeys = filterKeys
    .split(',')
    .filter(i => i !== groupName)
    .filter(i => i && i.length > 0)
    .join(',')
  newFilterKeys.length > 0 ? params.set(FILTER_KEYS_PARAM, newFilterKeys) : params.delete(FILTER_KEYS_PARAM)
}

const updateActive = (active, { type, checked, group, value, label, groupTitle }) => {
  if (!groupTitle) groupTitle = group

  if (checked && type === 'checklist' && active[groupTitle]) {
    active[groupTitle] = [...new Set([...active[groupTitle], { value, label }])]
  } else if (checked) {
    active[groupTitle] = [{ value, label }]
  } else {
    if (active[groupTitle].length === 1) delete active[groupTitle]
    else active[groupTitle] = active[groupTitle].filter(item => item.value !== value)
  }
}

export const onFilterClear = ({
  format,
  lang,
  categoryCode,
  collectionId,
  ids,
  viewSize,
  userId,
  ipAddress,
  dispatch
}) => {
  return () => {
    dispatch(isLoading(true))
    const url = new URL(global.document.location.href)
    const { origin, searchParams } = url

    const filterKeys = searchParams.get(FILTER_KEYS_PARAM)
    if (filterKeys && filterKeys.length > 0) {
      filterKeys.split(',').forEach(key => searchParams.delete(key))
    }

    searchParams.delete(FILTER_KEYS_PARAM)
    searchParams.delete('currentPage')

    updateWindowUrl(url.toString())

    return axios
      .get(
        getXhrUrl({
          origin,
          format,
          lang,
          userId,
          categoryCode,
          collectionId,
          ids,
          viewSize,
          searchParams
        }),
        {
          headers: { ip: ipAddress }
        }
      )
      .then(({ data }) => {
        const { products, meta, filters, breadcrumbs, page: pageData } = data || {}
        if (data.products?.collection?.length) {
          dispatch(
            setData({
              products,
              meta,
              filters: { ...filters, active: {} },
              breadcrumbs,
              page: {
                ...pageData,
                page: 1
              }
            })
          )
        }
        dispatch(isLoading(false))
      })
  }
}

export const shouldStopProcessing = (item, title, value, active, type) =>
  !item.checked &&
  (!active[title] || active[title].filter(filter => filter.value && filter.value === value).length < 1) &&
  type !== 'range'

const getFilterNameValue = (groupTitle, collection) => {
  return collection?.find(c => c.title === groupTitle)?.name
}

export function updateWindowUrl(urlStr) {
  const url = urlStr.replace(/\+/g, '%20')
  global.window.history.pushState({ timestamp: new Date().getTime() }, '', url)
}
